<template>
  <div
    class="text-app-color flex relative items-center w-full text-15 rounded-10 p-5"
    :class="isDarkMode ? 'bg-book' : 'bg-grey-200'"
    @click="toggle"
  >
    <div
      class="w-1/2 font-semibold text-center cursor-pointer p-5 z-5"
      :class="modelValue ? buttonClasses : 'text-grey-950'"
    >
      <slot name="title0">{{ titles[0] }}</slot>
    </div>

    <div class="active-item absolute rounded-10 z-1"
         :class="[
           {'active-switcher-item': !modelValue},
           isDarkMode ? 'bg-project' : 'bg-white shadow-switcher border-grey-580'
         ]"
    />

    <div
      class="w-1/2 font-semibold text-center cursor-pointer p-5 z-5"
      :class="!modelValue ? buttonClasses : 'text-grey-950'"
    >
      <slot name="title1">{{ titles[1] }}</slot>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'

export default defineComponent({
  props: {
    modelValue: Boolean,
    isDarkMode: Boolean,
    titles: { type: Array }
  },

  emits: ['update:modelValue', 'onChange'],

  setup (props, { emit }) {
    const buttonClasses = computed(() => state => {
      return props.isDarkMode ? 'text-white' : 'text-dark-600 shadow-dropdown '
    })

    function toggle () {
      emit('update:modelValue', !props.modelValue)
      emit('onChange')
    }

    return {
      buttonClasses,
      toggle
    }
  }
})
</script>

<style lang="scss" scoped>
.active-item {
  height: 80%;
  width: 48.2%;
  transition: ease-in-out 0.2s;

  &.active-switcher-item {
    transform: translateX(100%);
  }
}
</style>
